export enum SuccessConfirmationCode {
  SaveApplication = 1,
  UpdateApplication = 2,
  SubmitApplication = 3,
  CancelApplication = 4,
  SubmitTask = 5,
  CloseApplication = 6
}
